module.exports = {
  "version": "0.30.0"
};


//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/env/data.js
// module id = 297
// module chunks = 1